import { render } from "./AvisoListagem.vue?vue&type=template&id=3d0adc50&scoped=true"
const script = {}

import "./AvisoListagem.vue?vue&type=style&index=0&id=3d0adc50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0adc50"]])

export default __exports__